export const LINK_CERTIFICATE_OF_TRUST =
  "https://www.bsigroup.com/en-IE/validate-bsi-issued-certificates/client-directory-profile/PT_EMO-0047792292-000";
export const API_BASE_URL = "https://api2.emos.id/generatesp/graphql";
